import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { localize } from '../../i18n/locale';

const Loading = () => {
    const navigate = useNavigate();
    const { i18n } = useTranslation();
    const tr = (ko, en) => localize(i18n.resolvedLanguage || i18n.language, { ko, en });

    useEffect(() => {
        const timer = setTimeout(() => {
            navigate('/chugumi-test/result');
        }, 3000);

        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <div className="loading-container">
            <div className="loading-content">
                <div className="spinner"></div>
                <h2>{tr('당신의 추구미를 분석하고 있어요', 'Analyzing your Chugumi preferences')}</h2>
                <p>{tr('잠시만 기다려주세요...', 'Please wait a moment...')}</p>

                <div className="loading-steps">
                    <span className="step done">{tr('✓ 답변 수집', '✓ Answers Collected')}</span>
                    <span className="step active">{tr('... 성향 매칭', '... Matching Preferences')}</span>
                    <span className="step">{tr('결과 생성', 'Generating Result')}</span>
                </div>
            </div>

            <style jsx>{`
                .loading-container {
                    min-height: 100vh;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: linear-gradient(135deg, #0f172a 0%, #1e1b4b 100%);
                    color: white;
                }

                .loading-content {
                    text-align: center;
                }

                .spinner {
                    width: 60px;
                    height: 60px;
                    border: 4px solid rgba(255,255,255,0.1);
                    border-left-color: #3b82f6;
                    border-radius: 50%;
                    margin: 0 auto 2rem;
                    animation: spin 1s linear infinite;
                }

                h2 {
                    font-size: 1.5rem;
                    margin-bottom: 0.5rem;
                }

                p {
                    color: #94a3b8;
                    margin-bottom: 2rem;
                }

                .loading-steps {
                    display: flex;
                    gap: 1rem;
                    justify-content: center;
                    font-size: 0.9rem;
                }

                .step {
                    color: #475569;
                    padding: 0.25rem 0.75rem;
                    border-radius: 100px;
                    background: rgba(255,255,255,0.05);
                }

                .step.done {
                    color: #4ade80;
                    background: rgba(74, 222, 128, 0.1);
                }

                .step.active {
                    color: #3b82f6;
                    background: rgba(59, 130, 246, 0.1);
                    animation: pulse 1.5s infinite;
                }

                @keyframes spin {
                    to { transform: rotate(360deg); }
                }

                @keyframes pulse {
                    0% { opacity: 0.5; }
                    50% { opacity: 1; }
                    100% { opacity: 0.5; }
                }
            `}</style>
        </div>
    );
};

export default Loading;
